// emptyState — what the feed's blank area MEANS, as a rule with a name (F-021, 2026-09-05).
//
// Measured on the owner's own Desk: a street search whose RPC hit the 8 s net (`search rpc 500:
// canceling statement due to statement timeout`) rendered "ამ ფილტრებით არაფერი მოიძებნა" —
// the EMPTY state — while the database held 41 active clusters for that exact request. The
// fetch's catch blanked the entries, and a blank feed with a filter on reads as "nothing found".
// A timeout is not a finding. The four states below are mutually exclusive and the error one
// wins over the empty one, always.
export function feedEmptyKind ({ error = null, fetching = false, total = 0, rows = 0 } = {}) {
  if (error) return 'error'
  if (fetching) return 'searching'
  if (rows > 0 || total > 0) return 'results'
  return 'empty'
}
